import React from "react"
import { StyleSheet, Text, View } from "react-native"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { theme } from "@common/theme/theme"
import {
    COMMITMENT_COPY,
    formatNameOfOffer,
} from "../constants/inscriptionFormats"
import {
    monthlyPriceLabel,
    quoteIsWithoutCommitment,
} from "../utils/formulaChoice"

/**
 * Le pied de page des étapes où la formule se compose. La formule et son prix
 * voyagent AVEC le bouton : le parent voit ce qu'il achète au moment où il
 * décide, sans remonter la page. Tout y vient du devis — le volume, le format
 * et l'engagement réellement vendus — et rien ne s'affiche sans lui
 * (`quote` nul : le bouton seul, sans prix plutôt qu'avec un prix faux).
 * `recap` à faux tait la formule quand la page la dit déjà juste au-dessus.
 */
const FormulaFooter = ({ quote, recap = true, disabled, onPress }) => (
    <View style={styles.footer}>
        {quote && recap ? (
            <View style={styles.recap}>
                <Text style={styles.formula}>
                    {quote.weekly_hours}
                    {"\u00a0"}h/semaine · {formatNameOfOffer(quote.offer_type)}
                </Text>
                <Text style={styles.commitment}>
                    {quoteIsWithoutCommitment(quote)
                        ? COMMITMENT_COPY.footerNoCommitment
                        : COMMITMENT_COPY.label}
                </Text>
            </View>
        ) : null}
        <FilledButtonM
            label={
                quote && Number.isFinite(quote.monthly_price_cents)
                    ? `CONTINUER · ${monthlyPriceLabel(quote)}`
                    : "CONTINUER"
            }
            // Le bouton met son libellé en capitales : « €/mois » doit garder
            // les siennes.
            labelStyle={styles.ctaLabel}
            onPress={onPress}
            disabled={disabled}
            color={disabled ? theme.colors.lightMore : theme.colors.primary}
            style={{ width: "100%", marginBottom: 0 }}
        />
    </View>
)

const styles = StyleSheet.create({
    footer: {
        paddingVertical: 14,
        borderTopWidth: 1,
        borderTopColor: theme.colors.lightMore,
        backgroundColor: theme.colors.white,
    },
    recap: { marginBottom: 10, gap: 1 },
    formula: {
        fontFamily: "Montserrat-Bold",
        fontSize: 13,
        color: theme.colors.primaryDark || theme.colors.primary,
    },
    commitment: {
        fontFamily: "Montserrat-Medium",
        fontSize: 12.5,
        color: theme.colors.grey,
    },
    ctaLabel: { textTransform: "none", letterSpacing: 0.4 },
})

export default FormulaFooter
